import React from 'react'

import { useCollection, useCurrentCollectionId } from 'hooks/menu-collections'
import { useIsFeaturedRangeMerchandisingEnabled } from 'routes/Menu/domains/menu'

import { getOldCollectionMerchandisingHeader } from '../../../MenuExperience/CollectionScreen/getOldCollectionMerchandisingHeader'
import { useBrandHeadersInfo } from '../../../domains/brand'
import { useShouldRemoveMerchandisingBanner } from '../useShouldRemoveMerchandisingBanner'
import { MerchandisingHeader } from './MerchandisingHeader'
import { useCollectionHeaders } from './hooks'

const CollectionHeaderWrapper = () => {
  const isFeaturedRangeMerchandisingEnabled = useIsFeaturedRangeMerchandisingEnabled()
  const currentCollectionId = useCurrentCollectionId()
  const collection = useCollection(currentCollectionId)
  const { headers, collectionsPerMenu } = useBrandHeadersInfo(isFeaturedRangeMerchandisingEnabled)
  const collectionsHeaders = useCollectionHeaders(headers, collectionsPerMenu)
  const merchandisingHeader = isFeaturedRangeMerchandisingEnabled
    ? getOldCollectionMerchandisingHeader(collection?.merchandising)
    : collectionsHeaders

  const removeMerchandisingBanner = useShouldRemoveMerchandisingBanner()

  if (!merchandisingHeader || removeMerchandisingBanner) {
    return null
  }

  return <MerchandisingHeader header={merchandisingHeader} />
}

export { CollectionHeaderWrapper }
